import CloudUploadOutlinedIcon from "@mui/icons-material/CloudUploadOutlined";
import DeleteIcon from "@mui/icons-material/Delete";
import DownloadIcon from "@mui/icons-material/Download";
import { Chip, CircularProgress } from "@mui/material";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { addDays, format as formatDate } from "date-fns";
import _ from "lodash";
import React, { useEffect, useRef, useState } from "react";
import {
    AutocompleteElement,
    CheckboxElement,
    DatePickerElement,
    DateTimePickerElement,
    FormContainer,
    MultiSelectElement,
    PasswordElement,
    SelectElement,
    SwitchElement,
    TextFieldElement,
    useForm,
} from "react-hook-form-mui";
import { PMGrid, PMText } from "../../pmcomponents";
import { BaseWidget, BaseWidgetProps } from "../BaseWidget";
import "./FormWidget.scss";

export interface FormWidgetProps extends BaseWidgetProps {
    text?: string;
    textColor?: string;
    icon?: string;
    defaultValues?: Object;
    fieldsets?: Array<any>;
    fullWidth?: boolean;
    Onsubmit?: Function;
    submitOnChange?: boolean;
    submitButtonLabel?: string;
    showSubmitButton?: boolean;
    isLoading: boolean;
}

const FileUpload = (props) => {
    const { name } = props;
    const inputRef = useRef<HTMLInputElement>();
    const [files, setFiles] = useState<File[]>([]);
    
    const handleChange = (data) => {
        // data.target.files is a FileList object, Convert it to an array
        const newFiles = [...data.target.files];
        setFiles(newFiles);
        props.onChange(name, newFiles);
    };

    // const currentaValue = _.get(props?.fileFormData, props?.name);
    // useEffect(() => {
    //     if (currentaValue) {
    //         setFile(currentaValue);
    //     }
    // }, [currentaValue]);

    const handleDelete = (index) => {
        const newFiles = [...files];
        newFiles.splice(index, 1);
        
        setFiles(newFiles);
        props.onChange(name, newFiles);
    };

    // useEffect(() => {
    //     props.onChange(props?.name, null);
    // }, []);

    const decodeUrltoString = (url) => {
        if (url) {
            const parsedurl = new URL(url);
            return decodeURIComponent(parsedurl.pathname.split("/").pop());
        }
        return url;
    };

    return (
        <div className="file-input" onClick={() => inputRef.current?.click()}>
            <div>
                <input
                    {...props}
                    onChange={handleChange}
                    multiple
                    ref={inputRef}
                    name={`${props.name}_file`}
                    style={{ display: "none" }}
                ></input>
                <CloudUploadOutlinedIcon fontSize="large" sx={{ paddingRight: 1, opacity: 0.5 }} />
                {!(files || props?.url) && <span style={{ opacity: 0.5 }}>{props?.label}</span>}
                {files && (
                    <>
                    {
                        files.map((file, i) => {
                            return <Chip
                                key={i}
                                sx={{ maxWidth: "calc(100% - 30px)" }}
                                label={file?.name}
                                onClick={() => inputRef.current?.click()}
                                onDelete={() => handleDelete(i)}
                            />
                        })
                    }
                    </>
                )}
                {!files && props.url && (
                    <Chip
                        sx={{ maxWidth: "calc(100% - 30px)" }}
                        label={decodeUrltoString(props.url)}
                        component="a"
                        href={props.url}
                        onDelete={() => {}}
                        clickable
                        deleteIcon={<DownloadIcon />}
                    />
                )}
            </div>
        </div>
    );
};

export const FormWidget = (props: FormWidgetProps) => {
    const {
        submitOnChange,
        showSubmitButton,
        submitButtonLabel,
        Onsubmit,
        defaultValues,
        fullWidth,
        direction,
        ...baseProps
    } = props;
    const [fieldsetCount, setFieldsetCount] = useState([]);
    // const [fieldSetDefaultValue, setFieldSetDefaultValue] = useState([]);
    // const [currentForm, setCurrentForm] = useState({});
    const [fileFormData, setFileFormData] = useState(new FormData());
    const formContext = useForm({
        // Set default values
        values: defaultValues,
    });
    const {
        watch,
        reset,
        control,
        formState: { isDirty, isValid },
        handleSubmit,
        setValue,
        getValues,
    } = formContext;
    // let timer = null;

    // const formData = useWatch({ control });

    const addValidationMsg = (validation) => {
        Object.keys(validation).forEach((type) => {
            let value = validation[type].value || validation[type];
            switch (type) {
                case "min":
                    validation[type] = { value: value, message: `Value should be greater than ${value}` };
                    break;

                case "max":
                    validation[type] = { value: value, message: `Value should be less than ${value}` };
                    break;

                case "minLength":
                    validation[type] = { value: value, message: `Length should be greater than ${value}` };
                    break;

                case "maxLength":
                    validation[type] = { value: value, message: `Length should be less than ${value}` };
                    break;

                case "pattern":
                    validation[type] = { value: new RegExp(value), message: `Invalid value` };
                    break;

                default:
                    break;
            }
        });
        return validation;
    };
    const getDate = (dateDelta) => {
        if (!isNaN(dateDelta)) {
            let today = addDays(new Date(), dateDelta);
            return today;
        }
        return dateDelta;
    };

    // const checkValue = (data) => {
    //     let emptyValue = false;
    //     if (data) {
    //         Object.keys(data).forEach((ele) => {
    //             if (ele) {
    //                 emptyValue = true;
    //             }
    //         });
    //     }
    //     return emptyValue;
    // };
    // useEffect(() => {
    //     let formDataTemp = { ...formData };
    //     if (formData && checkValue(formData)) {
    //         if (fileFormData) formDataTemp = _.merge(formDataTemp, fileFormData);
    //         if (props.Onchange && !_.isEqual(formDataTemp, props.defaultValues)) {
    //             props.Onchange(formDataTemp);
    //         }
    //     }
    // }, [formData]);

    const onSubmit = (data) => {
        console.log("Submitted Form Data", data);
        if (isValid && props.Onsubmit) {
            if (fileFormData) data = _.merge(data, fileFormData);
            // props.Onsubmit(data);
            props.Onsubmit(convertDate(data));
        }
    };

    const convertDate = (data) => {
        Object.keys(data).forEach((element) => {
            const el = data[element];
            if (el instanceof Date) {
                data[element] = formatDate(el, "yyyy-MM-dd");
            }
        });
        return data;
    };
    useEffect(() => {
        let fieldsetCountTemp = [...fieldsetCount];
        props.fieldsets.map((fieldset, fsIndex) => {
            if (fieldset.group) {
                fieldsetCountTemp[fsIndex] = fieldsetCountTemp[fsIndex] || fieldset.count;
            } else {
                fieldsetCountTemp[fsIndex] = 1;
            }
        });
        setFieldsetCount([...fieldsetCountTemp]);
    }, [props.fieldsets]);

    // useEffect(() => {
    //     if (props?.defaultValues) {
    //         if (Object.keys(props.defaultValues).length !== 0) {
    //             let currentValue = formContext.getValues();
    //             Object.keys(props.defaultValues).forEach((element) => {
    //                 if (currentValue[element] !== props.defaultValues[element]) {
    //                     currentValue[element] = props.defaultValues[element];
    //                 }
    //             });
    //             reset({ ...currentValue });
    //         }
    //     }
    // }, [props.defaultValues]);
    const removeFromField = (fsindex, index, group, callback) => {
        let fieldsetCountTemp = [...fieldsetCount];
        fieldsetCountTemp[fsindex] = fieldsetCountTemp[fsindex] - 1;
        let currentValue = formContext.getValues();
        let fieldsetValue = null;
        if (currentValue[group] && currentValue[group][index]) {
            fieldsetValue = currentValue[group][index];
            currentValue[group].splice(index, 1);
        }
        let filesetValue = null;
        if (fileFormData[group][index]) {
            filesetValue = fileFormData[group][index];
            fileFormData[group].splice(index, 1);
        }
        if (callback) {
            callback(fieldsetValue || filesetValue);
        }
        reset({ ...currentValue });
        setFieldsetCount([...fieldsetCountTemp]);
    };
    const addFromField = (index) => {
        let fieldsetCountTemp = [...fieldsetCount];
        fieldsetCountTemp[index] = fieldsetCountTemp[index] + 1;
        setFieldsetCount([...fieldsetCountTemp]);
    };

    const fileOnChange = (name, files) => {
        let fileFormDataTemp = { ...fileFormData };
        let jsonNames = name.split(/\[|\].|\]\[/);
        assign(fileFormDataTemp, jsonNames, files);
        setFileFormData(fileFormDataTemp);
    };

    const assign = (obj, keyPath, value) => {
        let lastKeyIndex = keyPath.length - 1;
        for (var i = 0; i < lastKeyIndex; ++i) {
            let key = keyPath[i];
            if (!(key in obj)) {
                if (keyPath[i + 1] && !isNaN(keyPath[i + 1])) {
                    obj[key] = [];
                } else {
                    obj[key] = {};
                }
            }
            obj = obj[key];
        }
        obj[keyPath[lastKeyIndex]] = value;
    };
    return (
        <BaseWidget {...baseProps} md={12}>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
                <FormContainer handleSubmit={handleSubmit(onSubmit)} formContext={formContext}>
                    <PMGrid
                        container
                        direction={direction || "column"}
                        spacing={2}
                        justifyContent="flex-start"
                        alignItems="flex-start"
                    >
                        {props.fieldsets.map((fieldset, fsIndex) => {
                            let rows = [];
                            if (fieldset.header) {
                                rows.push(
                                    !fieldset?.displayon && (
                                        <PMGrid key={`HEADER-${fsIndex}`}>
                                            <PMText
                                                variant="body1"
                                                sx={{ fontWeight: "600", width: "100%" }}
                                                color={baseProps.headerColor}
                                            >
                                                {fieldset.header}
                                            </PMText>
                                        </PMGrid>
                                    )
                                );
                            }
                            for (let index = 0; index < fieldsetCount[fsIndex]; index++) {
                                rows.push(
                                    <PMGrid
                                        key={`GRID-${fsIndex}-${index}`}
                                        container
                                        direction={fieldset.direction || "row"}
                                        spacing={2}
                                        justifyContent="flex-start"
                                        alignItems="flex-start"
                                        sx={fieldset?.delete ? { "padding-right": "30px" } : {}}
                                    >
                                        { 
                                            fieldset.fields.map((fieldItem, fIndex) => {
                                            let field = { ...fieldItem };
                                            let fieldType: any = TextFieldElement;
                                            let fieldStyleProps = {};
                                            let mdGridSize = field.md || 12 / Math.min(fieldset.fields?.length || 4, 12);

                                            if (field.minDate) {
                                                field.minDate = getDate(field.minDate);
                                            }
                                            if (field.maxDate) {
                                                field.maxDate = getDate(field.maxDate);
                                            }
                                            if (field["validation"]) {
                                                field["validation"] = addValidationMsg(field["validation"]);
                                            }
                                            if (props.fullWidth || fieldset.fullWidth || field.fullWidth) {
                                                field["fullWidth"] = true;
                                                fieldStyleProps["width"] = "100%";
                                            }
                                            let fieldDefault = defaultValues ? defaultValues[field.name] || "" : "";
                                            if (fieldset.group) {
                                                field.name = `${fieldset.group}[${index}].${field.name}`;
                                                fieldDefault = _.get(defaultValues, field.name);
                                            }
                                            if (!field.inputProps) {
                                                field.inputProps = {};
                                            }

                                            if (field.prefix) {
                                                field.inputProps.startAdornment = (
                                                    <InputAdornment position="start">{field.prefix}</InputAdornment>
                                                );
                                            }

                                            if (field.suffix) {
                                                field.inputProps.endAdornment = (
                                                    <InputAdornment position="end">{field.suffix}</InputAdornment>
                                                );
                                            }
                                            let className = "formWidth";
                                            var changeEvent = "onBlur";

                                            switch (field.type) {
                                                case "text":
                                                case "number":
                                                    fieldType = TextFieldElement;
                                                    break;
                                                case "file":
                                                    fieldType = FileUpload;
                                                    field.onChange = fileOnChange;
                                                    field.url = fieldDefault;
                                                    field.fileFormData = fileFormData;
                                                    field.InputLabelProps = { shrink: true };
                                                    break;
                                                case "autocomplete":
                                                    fieldType = AutocompleteElement;
                                                    changeEvent = "onChange";
                                                    break;
                                                case "select":
                                                    fieldType = SelectElement;
                                                    changeEvent = "onChange";
                                                    break;
                                                case "multiselect":
                                                    fieldType = MultiSelectElement;
                                                    changeEvent = "onChange";
                                                    break;
                                                case "switch":
                                                    fieldType = SwitchElement;
                                                    changeEvent = "onChange";
                                                    break;
                                                case "checkbox":
                                                    fieldType = CheckboxElement;
                                                    fieldStyleProps = {};
                                                    className = "";
                                                    changeEvent = "onChange";
                                                    break;
                                                case "password":
                                                    fieldType = PasswordElement;
                                                    break;
                                                case "date":
                                                    fieldType = DatePickerElement;
                                                    field.format = "dd-MMM-yyyy";
                                                    changeEvent = "onChange";
                                                    break;
                                                case "datetime":
                                                    fieldType = DateTimePickerElement;
                                                    field.format = "dd-MMM-yyyy h:m a";
                                                    changeEvent = "onChange";
                                                    break;
                                                case "display":
                                                    fieldType = TextFieldElement;
                                                    field.disabled = true;
                                                    fieldStyleProps["display"] = fieldDefault ? "" : "none";
                                                    fieldStyleProps["& fieldset"] = { border: "none" };
                                                    break;
                                                case "hidden":
                                                    fieldType = TextFieldElement;
                                                    fieldStyleProps["display"] = "none";
                                                    break;
                                            }

                                            if (props.submitOnChange == true) {
                                                if (field[changeEvent]) {
                                                    const onChange = field[changeEvent];
                                                    field[changeEvent] = () => {
                                                        onChange();
                                                        handleSubmit(onSubmit)();
                                                    };
                                                } else {
                                                    field[changeEvent] = handleSubmit(onSubmit);
                                                }
                                            }

                                            return (
                                                !field?.displayon && (
                                                    <PMGrid
                                                        md={mdGridSize}
                                                        xs={12}
                                                        key={`Field-${fIndex}-${index}`}
                                                        sx={fieldStyleProps}
                                                    >
                                                        {React.createElement(fieldType, {
                                                            ...field,
                                                            className: className,
                                                            InputProps: field.inputProps,
                                                            sx: { width: "100%" },
                                                        })}
                                                    </PMGrid>
                                                )
                                            );
                                        })}
                                        {fieldset?.delete && fieldsetCount[fsIndex] != 1 && (
                                            <IconButton
                                                className="deleteButton"
                                                aria-label="delete"
                                                color="error"
                                                onClick={() =>
                                                    removeFromField(fsIndex, index, fieldset.group, fieldset?.onDelete)
                                                }
                                            >
                                                <DeleteIcon />
                                            </IconButton>
                                        )}
                                    </PMGrid>
                                );
                            }
                            if (fieldset?.additiontitle) {
                                rows.push(
                                    <PMGrid
                                        container
                                        key={`Title-${fsIndex}`}
                                        justifyContent="flex-end"
                                        sx={{ "margin-top": 10 }}
                                    >
                                        <Button variant="outlined" onClick={() => addFromField(fsIndex)}>
                                            {fieldset?.additiontitle}
                                        </Button>
                                    </PMGrid>
                                );
                            }
                            return rows;
                        })}
                        {showSubmitButton ? (
                            <>
                                <PMGrid container justifyContent="flex-end" sx={{ "margin-top": 10 }}>
                                    <Button variant="contained" type="submit" sx={{ minWidth: 150 }}>
                                        {props.isLoading ? (
                                            <CircularProgress size={25} color="inherit" />
                                        ) : (
                                            submitButtonLabel
                                        )}
                                    </Button>
                                    {/* <Button variant="contained" type="submit" onClick={onSubmit}>
                            {props.submitButtonLabel}
                        </Button> */}
                                </PMGrid>
                            </>
                        ) : (
                            <></>
                        )}
                    </PMGrid>
                </FormContainer>
            </LocalizationProvider>
        </BaseWidget>
    );
};

FormWidget.defaultProps = {
    direction: "column",
    submitButtonLabel: "Submit",
    fullWidth: false,
    showSubmitButton: true,
};

export default FormWidget;
